export default __webpack_public_path__ + "static/media/mw.c9b6345c.svg";